export const getUserName = (): string | null => {
  console.log('🔍 Getting user name from authentication sources...');
  
  // Check SMS admin authentication first
  const smsAdminAuth = localStorage.getItem('sms_admin_auth');
  if (smsAdminAuth) {
    try {
      const adminData = JSON.parse(smsAdminAuth);
      if (adminData.authenticated && adminData.expiry > new Date().getTime()) {
        const name = `Admin (${adminData.phoneNumber || 'SMS'})`;
        console.log('✅ Using SMS admin name:', name);
        return name;
      }
    } catch (error) {
      console.error('❌ Error parsing SMS admin auth data:', error);
    }
  }
  
  // Check for SMS staff authentication
  const smsAuth = localStorage.getItem('staff_sms_auth');
  if (smsAuth) {
    try {
      const authData = JSON.parse(smsAuth);
      if (authData.authenticated && authData.expiry > new Date().getTime()) {
        const name = `Staff (${authData.phoneNumber || 'SMS'})`;
        console.log('✅ Using SMS staff name:', name);
        return name;
      }
    } catch (error) {
      console.error('❌ Error parsing SMS staff auth data:', error);
    }
  }
  
  // Check location bypass
  const bypass = localStorage.getItem('location_bypass');
  if (bypass) {
    try {
      const bypassData = JSON.parse(bypass);
      if (bypassData.expiry > new Date().getTime()) {
        const name = 'Staff (Location Bypass)';
        console.log('✅ Using location bypass name:', name);
        return name;
      }
    } catch (error) {
      console.error('❌ Error parsing location bypass data:', error);
    }
  }
  
  // Fall back to regular user_name for other auth types
  const regularName = localStorage.getItem('user_name');
  console.log('📝 Using regular stored name:', regularName);
  return regularName;
};

export const getDeviceId = (): string => {
  let deviceId = localStorage.getItem('device_id');
  if (!deviceId) {
    deviceId = 'device_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
    localStorage.setItem('device_id', deviceId);
  }
  return deviceId;
};

export const getUserInfo = () => {
  const name = getUserName();
  const deviceId = getDeviceId();
  return { name, deviceId };
};

export const logActivity = (action: string, details?: any) => {
  const { name, deviceId } = getUserInfo();
  const timestamp = new Date().toISOString();
  
  console.log(`[${timestamp}] User: ${name || 'Unknown'} (${deviceId}) - ${action}`, details || '');
  
  // Store activity in localStorage for potential future use
  const activities = JSON.parse(localStorage.getItem('user_activities') || '[]');
  activities.push({
    timestamp,
    user: name,
    deviceId,
    action,
    details
  });
  
  // Keep only last 100 activities
  if (activities.length > 100) {
    activities.splice(0, activities.length - 100);
  }
  
  localStorage.setItem('user_activities', JSON.stringify(activities));
};
